import sectionCardCompareB1Css from '../css-snippets/section-card-compare-b1';

const html = `
<style>${sectionCardCompareB1Css}</style>
<div class="wrapper-container" id="" data-id="" data-attribute="wrapper-container" data-text-color="#000000"
  data-background-color="#ffffff" data-top-padding="true" data-bottom-padding="true"
  style="background-color: rgb(255, 255, 255); --text-color: #000000; color: rgb(0, 0, 0);">
  <div class="container wrapper-content">
    <div class="header-section" data-attribute="header-section" data-show-header="true">
      <h2 style="text-align:center;">See The Difference Kaliqo Makes</h2>
      <p style="text-align:center;">Most solar lights barely glow. Ours create warmth, depth, and atmosphere.</p>
    </div>
    <div class="wrap-compare">
      <div data-attribute="before" class="before-block item-block">
        <div class="wrap-img">
          <img data-attribute="image-before"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0d67cc2f0fd8dc77332e8.avif?w=1000"
            alt="">
        </div>
        <div data-attribute="text-before" data-background="#d16638" data-color="#ffffff" class="text-label"
          style="background-color: rgb(209, 102, 56); color: rgb(255, 255, 255);">Before</div>
      </div>
      <div data-attribute="after" class="after-block item-block">
        <div class="wrap-img">
          <img data-attribute="image-after"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0d682755af897f1b3acde.avif?w=1000"
            alt="">
        </div>
        <div data-attribute="text-after" data-background="#14ab30" data-color="#ffffff" class="text-label"
          style="background-color: rgb(20, 171, 48); color: rgb(255, 255, 255);">After</div>
      </div>
    </div>

    <div data-show-summary="true" data-border-color="#ffca44" class="summary-section" data-attribute="summary-section"
      data-background-color="#355052"
      style="border-color: rgb(255, 202, 68); border-width: 1px; border-style: solid; background-color: rgb(53, 80, 82);">
      <p><span style="color:hsl(0,0%,100%);">Most solar lights barely glow. Ours create warmth, depth, and atmosphere.
          From dull to dramatic — and it takes</span><span style="color:hsl(0,0%,0%);"> </span><span
          style="color:hsl(270,75%,60%);"><strong>less than 60 seconds </strong></span><span
          style="color:hsl(0,0%,100%);"><strong>to set up.</strong></span></p>
    </div>

    <div data-attribute="btn-cta" data-show-btn="true" class="wrap-button">
      <a data-attribute="button-link" data-background-color="#aa6d32" data-color="#ffffff" href="#"
        style="background-color: #aa6d32; color: #ffffff;">LIGHTEN UP YOUR SPACE NOW</a>
      <div class="sub-btn" data-attribute="sub-btn">🚛 Get faster shipping when you buy 2+</div>
    </div>
  </div>
</div>
`;
export default html;
